export default __webpack_public_path__ + "navigation-examples-custom-segue-thumbnail-480-1dbc37493d7a5df374478c18d60cd4fb.webp";